const parallax = document.querySelector('.parallax');

if (parallax) {
}
